import { useFormat } from '@ideavivat/vivat-2';

export default {
  types: {
    _primaryControls: {
      width: '3rem',
    },
    _secondaryControls: {
      width: '2rem',
    },
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    _playPauseControls: {
      width: '3rem',
    },
    name: {
      name: 'ชื่อ',
      width: '2fr',
    },
    // eslint-disable-next-line
    schedule_time: {
      name: 'วันที่',
      width: '10rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
    // eslint-disable-next-line
    start_time: {
      name: 'เวลาเริ่ม',
      width: '6rem',
    },
    text: {
      name: 'หัวข้อคำถาม',
      width: '2fr',
    },
    // eslint-disable-next-line
    display_time: {
      name: 'ระยะเวลา',
      width: '6rem',
    },
    totalVote: {
      name: 'ผู้โหวต',
      width: '12rem',
    },
    // eslint-disable-next-line
    poll_type: {
      name: 'ประเภทคำถาม',
      width: '6rem',
      filter(val: any) {
        return val === 'CHOICE' ? 'ตัวเลือก' : 'หลายตัวเลือก';
      },
    },
    // eslint-disable-next-line
    updated_at: {
      name: 'แก้ไขล่าสุด',
      width: '6rem',
      filter(val: any) {
        return useFormat.date(val).displayShortThaiDateTime();
      },
    },
    _closesControls: {
      width: '4rem',
    },
  },
  sortable: ['schedule_time', 'name', 'start_time', 'text', 'display_time', 'totalVote', 'poll_type', 'updated_at'],
};
